import { BlankLayout, GeneralLayout } from 'layouts';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Accounts, { ViewAccount } from './Accounts';
import Dashboard from './Dashboard';

const Pages = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<BlankLayout />} />
      <Route element={<GeneralLayout />}>
        <Route index element={<Accounts />} />
        <Route path="language/*">
          <Route index element={<Dashboard />} />
        </Route>
        <Route path="view_account/:accountId/*" element={<ViewAccount />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

export default Pages;
